import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {JobHistory} from '../../monitoring.models';

// tslint:disable-next-line:no-empty-interface
export interface DialogData extends JobHistory {
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'delete-job-history-dialog',
    templateUrl: './delete-job-history-dialog.html',
})
// tslint:disable-next-line:component-class-suffix
export class DeleteJobHistoryDialog {
    constructor(
        public dialogRef: MatDialogRef<DeleteJobHistoryDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
